import axios from 'core/libs/axios';

export default class BaseApi {
  constructor(config = {}) {
    if (typeof config === 'string') {
      this.client = axios.create({ baseURL: config });
    } else {
      this.client = config.client || axios.create(config);
    }

    this.client.interceptors.response.use(
      this.handleRedirect,
    );

    this.client.interceptors.request.use(
      this.handleRequestUrl,
    );
  }

  transformRequestParams = params => {
    return Object.keys(params)
      .reduce((acc, name) => {
        const value = params[name];
        /**
        * Часто, запросы к API передаются как ...otherProps.
        *
        * axios не фильтрует передачу параметров.
        * Например children или другие лишние данные.
        * Из-за чего запрос либо не проходит, либо содержит в себе кучу ненужного.
        *
        * Фильтруем такие запросы вручную.
        */
        const type = typeof value;
        const isCorrectType = type === 'string' || type === 'number' || type === 'boolean' || Array.isArray(params[name]);

        if (type === 'string' && (!value || value.trim() === '')) {
          return acc;
        }

        if (isCorrectType) {
          acc[name] = Array.isArray(value) ? value.join() : value;
        }
        return acc;
      }, {});
  };

  getData = response => response && response.data;

  handleResponseError = error => {
    /**
     * Устанавливаем statusCode по которому резолвится appStatus
     * и рендерится компонент ErrorPage при SSR.
     */

    error.statusCode = error?.response?.status;

    return Promise.reject(error);
  };

  handleRequestUrl = request => {
    if (request.url) {
      request.url = encodeURI(request.url);
    }
    return request;
  };

  handleRequestError = error => Promise.reject(error);

  handleRedirect = (response) => {
    if (process.env.BROWSER_RUNTIME) {
      const contentType = response?.headers['content-type'] || '';
      const requestUrl = response.config?.url || '';
      const responseUrl = response.request?.responseURL || '';

      if (responseUrl
          && responseUrl !== requestUrl
          && !responseUrl.includes(requestUrl)
          && contentType.includes('text/html')
      ) {
        location.href = responseUrl;
        return new Promise(() => {});
      }
    }
    return response;
  };
}
